//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @return OK
   */
  apiV1AgendamentosContratos(
    matricula: number,
    contrato: number,
    local: number,
    cancelToken?: CancelToken
  ): Promise<ContratoCarregamentoResponseResult> {
    let url_ = this.baseUrl + '/api/v1/Agendamentos/contratos?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (contrato === undefined || contrato === null)
      throw new globalThis.Error("The parameter 'contrato' must be defined and cannot be null.");
    else url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    if (local === undefined || local === null)
      throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
    else url_ += 'local=' + encodeURIComponent('' + local) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosContratos(_response);
      });
  }

  protected processApiV1AgendamentosContratos(
    response: AxiosResponse
  ): Promise<ContratoCarregamentoResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ContratoCarregamentoResponseResult.fromJS(resultData200);
      return Promise.resolve<ContratoCarregamentoResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ContratoCarregamentoResponseResult>(null as any);
  }

  /**
   * @param dataInicial (optional)
   * @param placa (optional)
   * @param status (optional)
   * @return OK
   */
  apiV1AgendamentosGet(
    matricula: number,
    dataInicial?: Date | undefined,
    placa?: string | undefined,
    status?: FiltroAgendamento | undefined,
    cancelToken?: CancelToken
  ): Promise<AgendamentoResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/Agendamentos?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (dataInicial === null)
      throw new globalThis.Error("The parameter 'dataInicial' cannot be null.");
    else if (dataInicial !== undefined)
      url_ +=
        'dataInicial=' +
        encodeURIComponent(dataInicial ? '' + dataInicial.toISOString() : '') +
        '&';
    if (placa === null) throw new globalThis.Error("The parameter 'placa' cannot be null.");
    else if (placa !== undefined) url_ += 'placa=' + encodeURIComponent('' + placa) + '&';
    if (status === null) throw new globalThis.Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosGet(_response);
      });
  }

  protected processApiV1AgendamentosGet(
    response: AxiosResponse
  ): Promise<AgendamentoResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AgendamentoResponseListResult.fromJS(resultData200);
      return Promise.resolve<AgendamentoResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AgendamentoResponseListResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1AgendamentosPost(
    recaptcha: string,
    matricula: number,
    contrato: number,
    local: number,
    body: ContratoCarregamentoInsert,
    cancelToken?: CancelToken
  ): Promise<ContratoCarregamentoResponseResult> {
    let url_ = this.baseUrl + '/api/v1/Agendamentos?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (contrato === undefined || contrato === null)
      throw new globalThis.Error("The parameter 'contrato' must be defined and cannot be null.");
    else url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    if (local === undefined || local === null)
      throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
    else url_ += 'local=' + encodeURIComponent('' + local) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        recaptcha: recaptcha !== undefined && recaptcha !== null ? '' + recaptcha : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosPost(_response);
      });
  }

  protected processApiV1AgendamentosPost(
    response: AxiosResponse
  ): Promise<ContratoCarregamentoResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ContratoCarregamentoResponseResult.fromJS(resultData200);
      return Promise.resolve<ContratoCarregamentoResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ContratoCarregamentoResponseResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1AgendamentosDelete(
    matricula: number,
    contrato: number,
    placa: string,
    data: Date,
    local: number,
    cancelToken?: CancelToken
  ): Promise<ContratoCarregamentoResponseResult> {
    let url_ = this.baseUrl + '/api/v1/Agendamentos?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (contrato === undefined || contrato === null)
      throw new globalThis.Error("The parameter 'contrato' must be defined and cannot be null.");
    else url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    if (placa === undefined || placa === null)
      throw new globalThis.Error("The parameter 'placa' must be defined and cannot be null.");
    else url_ += 'placa=' + encodeURIComponent('' + placa) + '&';
    if (data === undefined || data === null)
      throw new globalThis.Error("The parameter 'data' must be defined and cannot be null.");
    else url_ += 'data=' + encodeURIComponent(data ? '' + data.toISOString() : '') + '&';
    if (local === undefined || local === null)
      throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
    else url_ += 'local=' + encodeURIComponent('' + local) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosDelete(_response);
      });
  }

  protected processApiV1AgendamentosDelete(
    response: AxiosResponse
  ): Promise<ContratoCarregamentoResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ContratoCarregamentoResponseResult.fromJS(resultData200);
      return Promise.resolve<ContratoCarregamentoResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ContratoCarregamentoResponseResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1AgendamentosFobFiliaisMatriz(
    matriz: number,
    cancelToken?: CancelToken
  ): Promise<MatriculasFilialResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/AgendamentosFob/filiais-matriz?';
    if (matriz === undefined || matriz === null)
      throw new globalThis.Error("The parameter 'matriz' must be defined and cannot be null.");
    else url_ += 'matriz=' + encodeURIComponent('' + matriz) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosFobFiliaisMatriz(_response);
      });
  }

  protected processApiV1AgendamentosFobFiliaisMatriz(
    response: AxiosResponse
  ): Promise<MatriculasFilialResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = MatriculasFilialResponseListResult.fromJS(resultData200);
      return Promise.resolve<MatriculasFilialResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<MatriculasFilialResponseListResult>(null as any);
  }

  /**
   * @param situacao (optional)
   * @param contrato (optional)
   * @return OK
   */
  apiV1AgendamentosFobContratosFobCliente(
    matricula: number,
    situacao?: number | undefined,
    contrato?: number | undefined,
    cancelToken?: CancelToken
  ): Promise<ContratosFobClienteResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/AgendamentosFob/contratos-fob-cliente?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (situacao === null) throw new globalThis.Error("The parameter 'situacao' cannot be null.");
    else if (situacao !== undefined) url_ += 'situacao=' + encodeURIComponent('' + situacao) + '&';
    if (contrato === null) throw new globalThis.Error("The parameter 'contrato' cannot be null.");
    else if (contrato !== undefined) url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosFobContratosFobCliente(_response);
      });
  }

  protected processApiV1AgendamentosFobContratosFobCliente(
    response: AxiosResponse
  ): Promise<ContratosFobClienteResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ContratosFobClienteResponseListResult.fromJS(resultData200);
      return Promise.resolve<ContratosFobClienteResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ContratosFobClienteResponseListResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1AgendamentosFobContratosFobFilial(
    matricula: number,
    contrato: number,
    cancelToken?: CancelToken
  ): Promise<ContratosFobFilialResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/AgendamentosFob/contratos-fob-filial?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (contrato === undefined || contrato === null)
      throw new globalThis.Error("The parameter 'contrato' must be defined and cannot be null.");
    else url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosFobContratosFobFilial(_response);
      });
  }

  protected processApiV1AgendamentosFobContratosFobFilial(
    response: AxiosResponse
  ): Promise<ContratosFobFilialResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ContratosFobFilialResponseListResult.fromJS(resultData200);
      return Promise.resolve<ContratosFobFilialResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ContratosFobFilialResponseListResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1AgendamentosFobDefinicaoQuantidade(
    local: number,
    contrato: number,
    cancelToken?: CancelToken
  ): Promise<DefinicaoQuantidadeResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/AgendamentosFob/definicao-quantidade?';
    if (local === undefined || local === null)
      throw new globalThis.Error("The parameter 'local' must be defined and cannot be null.");
    else url_ += 'local=' + encodeURIComponent('' + local) + '&';
    if (contrato === undefined || contrato === null)
      throw new globalThis.Error("The parameter 'contrato' must be defined and cannot be null.");
    else url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosFobDefinicaoQuantidade(_response);
      });
  }

  protected processApiV1AgendamentosFobDefinicaoQuantidade(
    response: AxiosResponse
  ): Promise<DefinicaoQuantidadeResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DefinicaoQuantidadeResponseListResult.fromJS(resultData200);
      return Promise.resolve<DefinicaoQuantidadeResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DefinicaoQuantidadeResponseListResult>(null as any);
  }

  /**
   * @param cnpj (optional)
   * @return OK
   */
  apiV1AgendamentosFobContratosFobCnpj(
    cnpj?: number | undefined,
    cancelToken?: CancelToken
  ): Promise<PermissoesFobTransportadoraResponseIEnumerableResult> {
    let url_ = this.baseUrl + '/api/v1/AgendamentosFob/contratos-fob-cnpj?';
    if (cnpj === null) throw new globalThis.Error("The parameter 'cnpj' cannot be null.");
    else if (cnpj !== undefined) url_ += 'cnpj=' + encodeURIComponent('' + cnpj) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosFobContratosFobCnpj(_response);
      });
  }

  protected processApiV1AgendamentosFobContratosFobCnpj(
    response: AxiosResponse
  ): Promise<PermissoesFobTransportadoraResponseIEnumerableResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PermissoesFobTransportadoraResponseIEnumerableResult.fromJS(resultData200);
      return Promise.resolve<PermissoesFobTransportadoraResponseIEnumerableResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PermissoesFobTransportadoraResponseIEnumerableResult>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV1AgendamentosFobManutencaoContratosTransportadoresPost(
    body?: ContratosTransportadoresDto | undefined,
    cancelToken?: CancelToken
  ): Promise<BooleanResult> {
    let url_ = this.baseUrl + '/api/v1/AgendamentosFob/manutencao-contratos-transportadores';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosFobManutencaoContratosTransportadoresPost(_response);
      });
  }

  protected processApiV1AgendamentosFobManutencaoContratosTransportadoresPost(
    response: AxiosResponse
  ): Promise<BooleanResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BooleanResult.fromJS(resultData200);
      return Promise.resolve<BooleanResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<BooleanResult>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV1AgendamentosFobManutencaoContratosTransportadoresPut(
    body?: ContratosTransportadoresDto | undefined,
    cancelToken?: CancelToken
  ): Promise<BooleanResult> {
    let url_ = this.baseUrl + '/api/v1/AgendamentosFob/manutencao-contratos-transportadores';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosFobManutencaoContratosTransportadoresPut(_response);
      });
  }

  protected processApiV1AgendamentosFobManutencaoContratosTransportadoresPut(
    response: AxiosResponse
  ): Promise<BooleanResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BooleanResult.fromJS(resultData200);
      return Promise.resolve<BooleanResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<BooleanResult>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV1AgendamentosFobRemoverContratosTransportadores(
    body?: ContratosTransportadoresDto | undefined,
    cancelToken?: CancelToken
  ): Promise<BooleanResult> {
    let url_ = this.baseUrl + '/api/v1/AgendamentosFob/remover-contratos-transportadores';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'DELETE',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1AgendamentosFobRemoverContratosTransportadores(_response);
      });
  }

  protected processApiV1AgendamentosFobRemoverContratosTransportadores(
    response: AxiosResponse
  ): Promise<BooleanResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BooleanResult.fromJS(resultData200);
      return Promise.resolve<BooleanResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<BooleanResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1ContratosCarregamento(
    matricula: number,
    tipoFrete: string,
    cancelToken?: CancelToken
  ): Promise<ContratosAbertosResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/contratos-carregamento?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (tipoFrete === undefined || tipoFrete === null)
      throw new globalThis.Error("The parameter 'tipoFrete' must be defined and cannot be null.");
    else url_ += 'tipoFrete=' + encodeURIComponent('' + tipoFrete) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1ContratosCarregamento(_response);
      });
  }

  protected processApiV1ContratosCarregamento(
    response: AxiosResponse
  ): Promise<ContratosAbertosResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ContratosAbertosResponseListResult.fromJS(resultData200);
      return Promise.resolve<ContratosAbertosResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ContratosAbertosResponseListResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1Infra(cancelToken?: CancelToken): Promise<StringStringKeyValuePairListResult> {
    let url_ = this.baseUrl + '/api/v1/Infra';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1Infra(_response);
      });
  }

  protected processApiV1Infra(
    response: AxiosResponse
  ): Promise<StringStringKeyValuePairListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = StringStringKeyValuePairListResult.fromJS(resultData200);
      return Promise.resolve<StringStringKeyValuePairListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<StringStringKeyValuePairListResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1Permissoes(cancelToken?: CancelToken): Promise<PermissoesTransportadoraResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/Permissoes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1Permissoes(_response);
      });
  }

  protected processApiV1Permissoes(
    response: AxiosResponse
  ): Promise<PermissoesTransportadoraResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PermissoesTransportadoraResponseListResult.fromJS(resultData200);
      return Promise.resolve<PermissoesTransportadoraResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PermissoesTransportadoraResponseListResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1PermissoesFob(
    cancelToken?: CancelToken
  ): Promise<PermissoesFobTransportadoraResponseResult> {
    let url_ = this.baseUrl + '/api/v1/Permissoes/Fob';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1PermissoesFob(_response);
      });
  }

  protected processApiV1PermissoesFob(
    response: AxiosResponse
  ): Promise<PermissoesFobTransportadoraResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PermissoesFobTransportadoraResponseResult.fromJS(resultData200);
      return Promise.resolve<PermissoesFobTransportadoraResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PermissoesFobTransportadoraResponseResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1RelatoriosVencimentos(
    matricula: number,
    dataInicial: Date,
    dataFinal: Date,
    cancelToken?: CancelToken
  ): Promise<RelatorioResponseResult> {
    let url_ = this.baseUrl + '/api/v1/Relatorios/vencimentos?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (dataInicial === undefined || dataInicial === null)
      throw new globalThis.Error("The parameter 'dataInicial' must be defined and cannot be null.");
    else
      url_ +=
        'dataInicial=' +
        encodeURIComponent(dataInicial ? '' + dataInicial.toISOString() : '') +
        '&';
    if (dataFinal === undefined || dataFinal === null)
      throw new globalThis.Error("The parameter 'dataFinal' must be defined and cannot be null.");
    else
      url_ +=
        'dataFinal=' + encodeURIComponent(dataFinal ? '' + dataFinal.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1RelatoriosVencimentos(_response);
      });
  }

  protected processApiV1RelatoriosVencimentos(
    response: AxiosResponse
  ): Promise<RelatorioResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RelatorioResponseResult.fromJS(resultData200);
      return Promise.resolve<RelatorioResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RelatorioResponseResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1RelatoriosCtesSolicitadas(
    matricula: number,
    data: Date,
    cancelToken?: CancelToken
  ): Promise<RelatorioResponseResult> {
    let url_ = this.baseUrl + '/api/v1/Relatorios/ctes/solicitadas?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (data === undefined || data === null)
      throw new globalThis.Error("The parameter 'data' must be defined and cannot be null.");
    else url_ += 'data=' + encodeURIComponent(data ? '' + data.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1RelatoriosCtesSolicitadas(_response);
      });
  }

  protected processApiV1RelatoriosCtesSolicitadas(
    response: AxiosResponse
  ): Promise<RelatorioResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RelatorioResponseResult.fromJS(resultData200);
      return Promise.resolve<RelatorioResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RelatorioResponseResult>(null as any);
  }

  /**
   * @param dataInicial (optional)
   * @param contrato (optional)
   * @param ufIntraMunicipal (optional)
   * @param nota (optional)
   * @param cte (optional)
   * @param status (optional)
   * @return OK
   */
  apiV1SolicitacaoPagamentosGet(
    matricula: number,
    dataInicial?: Date | undefined,
    contrato?: number | undefined,
    ufIntraMunicipal?: string | undefined,
    nota?: number | undefined,
    cte?: number | undefined,
    status?: FiltroSolicitacaoPagamentoFrete | undefined,
    cancelToken?: CancelToken
  ): Promise<SolicitacaoPagamentoFreteResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (dataInicial === null)
      throw new globalThis.Error("The parameter 'dataInicial' cannot be null.");
    else if (dataInicial !== undefined)
      url_ +=
        'dataInicial=' +
        encodeURIComponent(dataInicial ? '' + dataInicial.toISOString() : '') +
        '&';
    if (contrato === null) throw new globalThis.Error("The parameter 'contrato' cannot be null.");
    else if (contrato !== undefined) url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    if (ufIntraMunicipal === null)
      throw new globalThis.Error("The parameter 'ufIntraMunicipal' cannot be null.");
    else if (ufIntraMunicipal !== undefined)
      url_ += 'ufIntraMunicipal=' + encodeURIComponent('' + ufIntraMunicipal) + '&';
    if (nota === null) throw new globalThis.Error("The parameter 'nota' cannot be null.");
    else if (nota !== undefined) url_ += 'nota=' + encodeURIComponent('' + nota) + '&';
    if (cte === null) throw new globalThis.Error("The parameter 'cte' cannot be null.");
    else if (cte !== undefined) url_ += 'cte=' + encodeURIComponent('' + cte) + '&';
    if (status === null) throw new globalThis.Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosGet(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosGet(
    response: AxiosResponse
  ): Promise<SolicitacaoPagamentoFreteResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SolicitacaoPagamentoFreteResponseListResult.fromJS(resultData200);
      return Promise.resolve<SolicitacaoPagamentoFreteResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SolicitacaoPagamentoFreteResponseListResult>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV1SolicitacaoPagamentosPut(
    matricula: number,
    contrato: number,
    nota: number,
    serie: string,
    acao: AcaoSolicitacaoPagamentoFrete,
    body?: SolicitacaoPagamentoFreteUpdate | undefined,
    cancelToken?: CancelToken
  ): Promise<SolicitacaoPagamentoFreteResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (contrato === undefined || contrato === null)
      throw new globalThis.Error("The parameter 'contrato' must be defined and cannot be null.");
    else url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    if (nota === undefined || nota === null)
      throw new globalThis.Error("The parameter 'nota' must be defined and cannot be null.");
    else url_ += 'nota=' + encodeURIComponent('' + nota) + '&';
    if (serie === undefined || serie === null)
      throw new globalThis.Error("The parameter 'serie' must be defined and cannot be null.");
    else url_ += 'serie=' + encodeURIComponent('' + serie) + '&';
    if (acao === undefined || acao === null)
      throw new globalThis.Error("The parameter 'acao' must be defined and cannot be null.");
    else url_ += 'acao=' + encodeURIComponent('' + acao) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosPut(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosPut(
    response: AxiosResponse
  ): Promise<SolicitacaoPagamentoFreteResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SolicitacaoPagamentoFreteResponseListResult.fromJS(resultData200);
      return Promise.resolve<SolicitacaoPagamentoFreteResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SolicitacaoPagamentoFreteResponseListResult>(null as any);
  }

  /**
   * @param contrato (optional)
   * @param nota (optional)
   * @param cteNfse (optional)
   * @param serieCteNfse (optional)
   * @param situacao (optional)
   * @param ufIntra (optional)
   * @param tipoContrato (optional)
   * @return OK
   */
  apiV1SolicitacaoPagamentosDex(
    matriculas: string,
    dataInicial: Date,
    dataFinal: Date,
    contrato?: number | undefined,
    nota?: number | undefined,
    cteNfse?: number | undefined,
    serieCteNfse?: string | undefined,
    situacao?: FiltroSolicitacaoPagamentoFrete | undefined,
    ufIntra?: string | undefined,
    tipoContrato?: string | undefined,
    cancelToken?: CancelToken
  ): Promise<SolicitacaoPagamentoFreteResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos/dex?';
    if (matriculas === undefined || matriculas === null)
      throw new globalThis.Error("The parameter 'matriculas' must be defined and cannot be null.");
    else url_ += 'matriculas=' + encodeURIComponent('' + matriculas) + '&';
    if (dataInicial === undefined || dataInicial === null)
      throw new globalThis.Error("The parameter 'dataInicial' must be defined and cannot be null.");
    else
      url_ +=
        'dataInicial=' +
        encodeURIComponent(dataInicial ? '' + dataInicial.toISOString() : '') +
        '&';
    if (dataFinal === undefined || dataFinal === null)
      throw new globalThis.Error("The parameter 'dataFinal' must be defined and cannot be null.");
    else
      url_ +=
        'dataFinal=' + encodeURIComponent(dataFinal ? '' + dataFinal.toISOString() : '') + '&';
    if (contrato === null) throw new globalThis.Error("The parameter 'contrato' cannot be null.");
    else if (contrato !== undefined) url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    if (nota === null) throw new globalThis.Error("The parameter 'nota' cannot be null.");
    else if (nota !== undefined) url_ += 'nota=' + encodeURIComponent('' + nota) + '&';
    if (cteNfse === null) throw new globalThis.Error("The parameter 'cteNfse' cannot be null.");
    else if (cteNfse !== undefined) url_ += 'cteNfse=' + encodeURIComponent('' + cteNfse) + '&';
    if (serieCteNfse === null)
      throw new globalThis.Error("The parameter 'serieCteNfse' cannot be null.");
    else if (serieCteNfse !== undefined)
      url_ += 'serieCteNfse=' + encodeURIComponent('' + serieCteNfse) + '&';
    if (situacao === null) throw new globalThis.Error("The parameter 'situacao' cannot be null.");
    else if (situacao !== undefined) url_ += 'situacao=' + encodeURIComponent('' + situacao) + '&';
    if (ufIntra === null) throw new globalThis.Error("The parameter 'ufIntra' cannot be null.");
    else if (ufIntra !== undefined) url_ += 'ufIntra=' + encodeURIComponent('' + ufIntra) + '&';
    if (tipoContrato === null)
      throw new globalThis.Error("The parameter 'tipoContrato' cannot be null.");
    else if (tipoContrato !== undefined)
      url_ += 'tipoContrato=' + encodeURIComponent('' + tipoContrato) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosDex(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosDex(
    response: AxiosResponse
  ): Promise<SolicitacaoPagamentoFreteResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SolicitacaoPagamentoFreteResponseListResult.fromJS(resultData200);
      return Promise.resolve<SolicitacaoPagamentoFreteResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SolicitacaoPagamentoFreteResponseListResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1SolicitacaoPagamentosHistorico(
    matricula: number,
    contrato: number,
    nota: number,
    serie: number,
    cancelToken?: CancelToken
  ): Promise<HistoricoSolicitacaoPagamentoFreteResponseResult> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos/historico?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (contrato === undefined || contrato === null)
      throw new globalThis.Error("The parameter 'contrato' must be defined and cannot be null.");
    else url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    if (nota === undefined || nota === null)
      throw new globalThis.Error("The parameter 'nota' must be defined and cannot be null.");
    else url_ += 'nota=' + encodeURIComponent('' + nota) + '&';
    if (serie === undefined || serie === null)
      throw new globalThis.Error("The parameter 'serie' must be defined and cannot be null.");
    else url_ += 'serie=' + encodeURIComponent('' + serie) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosHistorico(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosHistorico(
    response: AxiosResponse
  ): Promise<HistoricoSolicitacaoPagamentoFreteResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = HistoricoSolicitacaoPagamentoFreteResponseResult.fromJS(resultData200);
      return Promise.resolve<HistoricoSolicitacaoPagamentoFreteResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<HistoricoSolicitacaoPagamentoFreteResponseResult>(null as any);
  }

  /**
   * @param body (optional)
   * @param matricula (optional)
   * @param contrato (optional)
   * @param nota (optional)
   * @param cteNfse (optional)
   * @param nfse (optional)
   * @param cte (optional)
   * @param ticket (optional)
   * @param nfseXml (optional)
   * @param cteLink (optional)
   * @param observacao (optional)
   * @return OK
   */
  apiV1SolicitacaoPagamentosAnexosPost(
    body?: Body | undefined,
    matricula?: number | undefined,
    contrato?: number | undefined,
    nota?: number | undefined,
    cteNfse?: number | undefined,
    nfse?: FileParameter | null | undefined,
    cte?: FileParameter | null | undefined,
    ticket?: FileParameter | null | undefined,
    nfseXml?: FileParameter | null | undefined,
    cteLink?: string | null | undefined,
    observacao?: string | null | undefined,
    cancelToken?: CancelToken
  ): Promise<SolicitacaoPagamentoFreteAnexoResponseResult> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos/anexos';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (matricula === null || matricula === undefined)
      throw new globalThis.Error("The parameter 'matricula' cannot be null.");
    else content_.append('Matricula', matricula.toString());
    if (contrato === null || contrato === undefined)
      throw new globalThis.Error("The parameter 'contrato' cannot be null.");
    else content_.append('Contrato', contrato.toString());
    if (nota === null || nota === undefined)
      throw new globalThis.Error("The parameter 'nota' cannot be null.");
    else content_.append('Nota', nota.toString());
    if (cteNfse === null || cteNfse === undefined)
      throw new globalThis.Error("The parameter 'cteNfse' cannot be null.");
    else content_.append('CteNfse', cteNfse.toString());
    if (nfse !== null && nfse !== undefined)
      content_.append('Nfse', nfse.data, nfse.fileName ? nfse.fileName : 'Nfse');
    if (cte !== null && cte !== undefined)
      content_.append('Cte', cte.data, cte.fileName ? cte.fileName : 'Cte');
    if (ticket !== null && ticket !== undefined)
      content_.append('Ticket', ticket.data, ticket.fileName ? ticket.fileName : 'Ticket');
    if (nfseXml !== null && nfseXml !== undefined)
      content_.append('NfseXml', nfseXml.data, nfseXml.fileName ? nfseXml.fileName : 'NfseXml');
    if (cteLink !== null && cteLink !== undefined) content_.append('CteLink', cteLink.toString());
    if (observacao !== null && observacao !== undefined)
      content_.append('Observacao', observacao.toString());

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosAnexosPost(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosAnexosPost(
    response: AxiosResponse
  ): Promise<SolicitacaoPagamentoFreteAnexoResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SolicitacaoPagamentoFreteAnexoResponseResult.fromJS(resultData200);
      return Promise.resolve<SolicitacaoPagamentoFreteAnexoResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SolicitacaoPagamentoFreteAnexoResponseResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1SolicitacaoPagamentosAnexosGet(
    matricula: number,
    contrato: number,
    nota: number,
    cte: number,
    cancelToken?: CancelToken
  ): Promise<SolicitacaoPagamentoFreteAnexoResponseResult> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos/anexos?';
    if (matricula === undefined || matricula === null)
      throw new globalThis.Error("The parameter 'matricula' must be defined and cannot be null.");
    else url_ += 'matricula=' + encodeURIComponent('' + matricula) + '&';
    if (contrato === undefined || contrato === null)
      throw new globalThis.Error("The parameter 'contrato' must be defined and cannot be null.");
    else url_ += 'contrato=' + encodeURIComponent('' + contrato) + '&';
    if (nota === undefined || nota === null)
      throw new globalThis.Error("The parameter 'nota' must be defined and cannot be null.");
    else url_ += 'nota=' + encodeURIComponent('' + nota) + '&';
    if (cte === undefined || cte === null)
      throw new globalThis.Error("The parameter 'cte' must be defined and cannot be null.");
    else url_ += 'cte=' + encodeURIComponent('' + cte) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosAnexosGet(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosAnexosGet(
    response: AxiosResponse
  ): Promise<SolicitacaoPagamentoFreteAnexoResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SolicitacaoPagamentoFreteAnexoResponseResult.fromJS(resultData200);
      return Promise.resolve<SolicitacaoPagamentoFreteAnexoResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<SolicitacaoPagamentoFreteAnexoResponseResult>(null as any);
  }

  /**
   * @return OK
   */
  apiV1SolicitacaoPagamentosAnexosDownload(
    anexoId: string,
    solicitacaoId: string,
    cancelToken?: CancelToken
  ): Promise<FileResponse> {
    let url_ =
      this.baseUrl + '/api/v1/solicitacao-pagamentos/{solicitacaoId}/anexos/{anexoId}/download';
    if (anexoId === undefined || anexoId === null)
      throw new globalThis.Error("The parameter 'anexoId' must be defined.");
    url_ = url_.replace('{anexoId}', encodeURIComponent('' + anexoId));
    if (solicitacaoId === undefined || solicitacaoId === null)
      throw new globalThis.Error("The parameter 'solicitacaoId' must be defined.");
    url_ = url_.replace('{solicitacaoId}', encodeURIComponent('' + solicitacaoId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosAnexosDownload(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosAnexosDownload(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers['content-type'] }),
        headers: _headers
      });
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException('Not Found', status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * @return No Content
   */
  apiV1SolicitacaoPagamentosAnexosDelete(
    anexoId: string,
    solicitacaoId: string,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos/{solicitacaoId}/anexos/{anexoId}';
    if (anexoId === undefined || anexoId === null)
      throw new globalThis.Error("The parameter 'anexoId' must be defined.");
    url_ = url_.replace('{anexoId}', encodeURIComponent('' + anexoId));
    if (solicitacaoId === undefined || solicitacaoId === null)
      throw new globalThis.Error("The parameter 'solicitacaoId' must be defined.");
    url_ = url_.replace('{solicitacaoId}', encodeURIComponent('' + solicitacaoId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosAnexosDelete(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosAnexosDelete(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException('Not Found', status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  apiV1SolicitacaoPagamentosObservacoesGet(
    cancelToken?: CancelToken
  ): Promise<ObservacaoPagamentoFreteResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos/observacoes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosObservacoesGet(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosObservacoesGet(
    response: AxiosResponse
  ): Promise<ObservacaoPagamentoFreteResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ObservacaoPagamentoFreteResponseListResult.fromJS(resultData200);
      return Promise.resolve<ObservacaoPagamentoFreteResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ObservacaoPagamentoFreteResponseListResult>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV1SolicitacaoPagamentosObservacoesPost(
    body?: ObservacaoPagamentoFreteRequest | undefined,
    cancelToken?: CancelToken
  ): Promise<ObservacaoPagamentoFreteResponseResult> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos/observacoes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosObservacoesPost(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosObservacoesPost(
    response: AxiosResponse
  ): Promise<ObservacaoPagamentoFreteResponseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ObservacaoPagamentoFreteResponseResult.fromJS(resultData200);
      return Promise.resolve<ObservacaoPagamentoFreteResponseResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ObservacaoPagamentoFreteResponseResult>(null as any);
  }

  /**
   * @return No Content
   */
  apiV1SolicitacaoPagamentosObservacoesDelete(
    id: number,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/v1/solicitacao-pagamentos/observacoes/{id}';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1SolicitacaoPagamentosObservacoesDelete(_response);
      });
  }

  protected processApiV1SolicitacaoPagamentosObservacoesDelete(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException('Not Found', status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  apiV1VeiculosTiposVeiculos(cancelToken?: CancelToken): Promise<TipoVeiculosResponseListResult> {
    let url_ = this.baseUrl + '/api/v1/veiculos/TiposVeiculos';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1VeiculosTiposVeiculos(_response);
      });
  }

  protected processApiV1VeiculosTiposVeiculos(
    response: AxiosResponse
  ): Promise<TipoVeiculosResponseListResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TipoVeiculosResponseListResult.fromJS(resultData200);
      return Promise.resolve<TipoVeiculosResponseListResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<TipoVeiculosResponseListResult>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV1VeiculosCadastroVeiculo(
    body?: PostVeiculoRequest | undefined,
    cancelToken?: CancelToken
  ): Promise<PostVeiculoRequestResult> {
    let url_ = this.baseUrl + '/api/v1/veiculos/CadastroVeiculo';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processApiV1VeiculosCadastroVeiculo(_response);
      });
  }

  protected processApiV1VeiculosCadastroVeiculo(
    response: AxiosResponse
  ): Promise<PostVeiculoRequestResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PostVeiculoRequestResult.fromJS(resultData200);
      return Promise.resolve<PostVeiculoRequestResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ExceptionDto.fromJS(resultData400);
      return throwException('Bad Request', status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PostVeiculoRequestResult>(null as any);
  }
}

export enum AcaoSolicitacaoPagamentoFrete {
  Atualiza = 'Atualiza',
  Solicita = 'Solicita'
}

export class AgendamentoResponse {
  placa?: string | undefined;
  contrato?: number;
  data?: Date | undefined;
  origem?: string | undefined;
  destino?: string | undefined;
  peso?: number;
  preco?: number;
  nota?: number;
  situacao?: string | undefined;
  local?: number;

  init(_data?: any) {
    if (_data) {
      this.placa = _data['placa'];
      this.contrato = _data['contrato'];
      this.data = _data['data'] ? new Date(_data['data'].toString()) : (undefined as any);
      this.origem = _data['origem'];
      this.destino = _data['destino'];
      this.peso = _data['peso'];
      this.preco = _data['preco'];
      this.nota = _data['nota'];
      this.situacao = _data['situacao'];
      this.local = _data['local'];
    }
  }

  static fromJS(data: any): AgendamentoResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AgendamentoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['placa'] = this.placa;
    data['contrato'] = this.contrato;
    data['data'] = this.data ? this.data.toISOString() : (undefined as any);
    data['origem'] = this.origem;
    data['destino'] = this.destino;
    data['peso'] = this.peso;
    data['preco'] = this.preco;
    data['nota'] = this.nota;
    data['situacao'] = this.situacao;
    data['local'] = this.local;
    return data;
  }
}

export class AgendamentoResponseListResult {
  data?: AgendamentoResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(AgendamentoResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): AgendamentoResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new AgendamentoResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class AnexoPagamentoFreteResponse {
  id?: string;
  tipoDocumento?: string | undefined;
  nomeOriginal?: string | undefined;
  contentType?: string | undefined;
  cteLink?: string | undefined;
  observacao?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.tipoDocumento = _data['tipoDocumento'];
      this.nomeOriginal = _data['nomeOriginal'];
      this.contentType = _data['contentType'];
      this.cteLink = _data['cteLink'];
      this.observacao = _data['observacao'];
    }
  }

  static fromJS(data: any): AnexoPagamentoFreteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AnexoPagamentoFreteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['tipoDocumento'] = this.tipoDocumento;
    data['nomeOriginal'] = this.nomeOriginal;
    data['contentType'] = this.contentType;
    data['cteLink'] = this.cteLink;
    data['observacao'] = this.observacao;
    return data;
  }
}

export class BooleanResult {
  data?: boolean;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.data = _data['data'];
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): BooleanResult {
    data = typeof data === 'object' ? data : {};
    let result = new BooleanResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data;
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class ContratoAgendamentoResponse {
  placa?: string | undefined;
  data?: Date | undefined;
  ordem?: number;
  peso?: number;
  preco?: number;
  armazem?: number;

  init(_data?: any) {
    if (_data) {
      this.placa = _data['placa'];
      this.data = _data['data'] ? new Date(_data['data'].toString()) : (undefined as any);
      this.ordem = _data['ordem'];
      this.peso = _data['peso'];
      this.preco = _data['preco'];
      this.armazem = _data['armazem'];
    }
  }

  static fromJS(data: any): ContratoAgendamentoResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ContratoAgendamentoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['placa'] = this.placa;
    data['data'] = this.data ? this.data.toISOString() : (undefined as any);
    data['ordem'] = this.ordem;
    data['peso'] = this.peso;
    data['preco'] = this.preco;
    data['armazem'] = this.armazem;
    return data;
  }
}

export class ContratoCarregamentoInsert {
  placa?: string | undefined;
  motorista?: string | undefined;
  cpf?: string | undefined;
  celularMotorista?: string | undefined;
  chegada?: Date;
  quantidadeACarregar?: number;
  eixos?: number;
  ordemCarregamentoPropria?: number;

  init(_data?: any) {
    if (_data) {
      this.placa = _data['placa'];
      this.motorista = _data['motorista'];
      this.cpf = _data['cpf'];
      this.celularMotorista = _data['celularMotorista'];
      this.chegada = _data['chegada'] ? new Date(_data['chegada'].toString()) : (undefined as any);
      this.quantidadeACarregar = _data['quantidadeACarregar'];
      this.eixos = _data['eixos'];
      this.ordemCarregamentoPropria = _data['ordemCarregamentoPropria'];
    }
  }

  static fromJS(data: any): ContratoCarregamentoInsert {
    data = typeof data === 'object' ? data : {};
    let result = new ContratoCarregamentoInsert();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['placa'] = this.placa;
    data['motorista'] = this.motorista;
    data['cpf'] = this.cpf;
    data['celularMotorista'] = this.celularMotorista;
    data['chegada'] = this.chegada ? this.chegada.toISOString() : (undefined as any);
    data['quantidadeACarregar'] = this.quantidadeACarregar;
    data['eixos'] = this.eixos;
    data['ordemCarregamentoPropria'] = this.ordemCarregamentoPropria;
    return data;
  }
}

export class ContratoCarregamentoResponse {
  contrato?: number;
  local?: number;
  descricaoLocal?: string | undefined;
  saldoTransportador?: number;
  produto?: number;
  descricaoProduto?: string | undefined;
  observacao?: string | undefined;
  detalhes?: ContratoAgendamentoResponse[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.contrato = _data['contrato'];
      this.local = _data['local'];
      this.descricaoLocal = _data['descricaoLocal'];
      this.saldoTransportador = _data['saldoTransportador'];
      this.produto = _data['produto'];
      this.descricaoProduto = _data['descricaoProduto'];
      this.observacao = _data['observacao'];
      if (Array.isArray(_data['detalhes'])) {
        this.detalhes = [] as any;
        for (let item of _data['detalhes'])
          this.detalhes!.push(ContratoAgendamentoResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ContratoCarregamentoResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ContratoCarregamentoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contrato'] = this.contrato;
    data['local'] = this.local;
    data['descricaoLocal'] = this.descricaoLocal;
    data['saldoTransportador'] = this.saldoTransportador;
    data['produto'] = this.produto;
    data['descricaoProduto'] = this.descricaoProduto;
    data['observacao'] = this.observacao;
    if (Array.isArray(this.detalhes)) {
      data['detalhes'] = [];
      for (let item of this.detalhes)
        data['detalhes'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export class ContratoCarregamentoResponseResult {
  data?: ContratoCarregamentoResponse;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      const contratoData = _data['data']?.['result'] ?? _data['data'];
      this.data = contratoData
        ? ContratoCarregamentoResponse.fromJS(contratoData)
        : (undefined as any);
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): ContratoCarregamentoResponseResult {
    data = typeof data === 'object' ? data : {};
    let result = new ContratoCarregamentoResponseResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data ? this.data.toJSON() : (undefined as any);
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class ContratosAbertosResponse {
  contrato?: number;
  local?: number;
  origem?: string | undefined;
  destino?: string | undefined;
  cidade?: string | undefined;
  observacao?: string | undefined;
  frete4?: number;
  frete5?: number;
  frete6?: number;
  frete7?: number;
  frete9?: number;
  saldo?: number;

  init(_data?: any) {
    if (_data) {
      this.contrato = _data['contrato'];
      this.local = _data['local'];
      this.origem = _data['origem'];
      this.destino = _data['destino'];
      this.cidade = _data['cidade'];
      this.observacao = _data['observacao'];
      this.frete4 = _data['frete4'];
      this.frete5 = _data['frete5'];
      this.frete6 = _data['frete6'];
      this.frete7 = _data['frete7'];
      this.frete9 = _data['frete9'];
      this.saldo = _data['saldo'];
    }
  }

  static fromJS(data: any): ContratosAbertosResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ContratosAbertosResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contrato'] = this.contrato;
    data['local'] = this.local;
    data['origem'] = this.origem;
    data['destino'] = this.destino;
    data['cidade'] = this.cidade;
    data['observacao'] = this.observacao;
    data['frete4'] = this.frete4;
    data['frete5'] = this.frete5;
    data['frete6'] = this.frete6;
    data['frete7'] = this.frete7;
    data['frete9'] = this.frete9;
    data['saldo'] = this.saldo;
    return data;
  }
}

export class ContratosAbertosResponseListResult {
  data?: ContratosAbertosResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(ContratosAbertosResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): ContratosAbertosResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new ContratosAbertosResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class ContratosFobClienteResponse {
  contrato!: number;
  produto!: string | undefined;
  quantidade!: number;
  saldo!: number;
  safra?: string | undefined;
  valor?: number | undefined;
  descricoes?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.contrato = _data['contrato'];
      this.produto = _data['produto'];
      this.quantidade = _data['quantidade'];
      this.saldo = _data['saldo'];
      this.safra = _data['safra'];
      this.valor = _data['valor'];
      if (Array.isArray(_data['descricoes'])) {
        this.descricoes = [] as any;
        for (let item of _data['descricoes']) this.descricoes!.push(item);
      }
    }
  }

  static fromJS(data: any): ContratosFobClienteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ContratosFobClienteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contrato'] = this.contrato;
    data['produto'] = this.produto;
    data['quantidade'] = this.quantidade;
    data['saldo'] = this.saldo;
    data['safra'] = this.safra;
    data['valor'] = this.valor;
    if (Array.isArray(this.descricoes)) {
      data['descricoes'] = [];
      for (let item of this.descricoes) data['descricoes'].push(item);
    }
    return data;
  }
}

export class ContratosFobClienteResponseListResult {
  data?: ContratosFobClienteResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(ContratosFobClienteResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): ContratosFobClienteResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new ContratosFobClienteResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class ContratosFobFilialResponse {
  embarque!: number;
  filial!: string | undefined;
  bairro!: string | undefined;
  saldo!: number;
  agendado!: number;

  init(_data?: any) {
    if (_data) {
      this.embarque = _data['embarque'];
      this.filial = _data['filial'];
      this.bairro = _data['bairro'];
      this.saldo = _data['saldo'];
      this.agendado = _data['agendado'];
    }
  }

  static fromJS(data: any): ContratosFobFilialResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ContratosFobFilialResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['embarque'] = this.embarque;
    data['filial'] = this.filial;
    data['bairro'] = this.bairro;
    data['saldo'] = this.saldo;
    data['agendado'] = this.agendado;
    return data;
  }
}

export class ContratosFobFilialResponseListResult {
  data?: ContratosFobFilialResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(ContratosFobFilialResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): ContratosFobFilialResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new ContratosFobFilialResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class ContratosTransportadoresDto {
  local!: number;
  contrato!: number;
  transportadora!: number;
  quantidade!: number;
  quantidadeTransportada?: number | undefined;
  obs?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.local = _data['local'];
      this.contrato = _data['contrato'];
      this.transportadora = _data['transportadora'];
      this.quantidade = _data['quantidade'];
      this.quantidadeTransportada = _data['quantidadeTransportada'];
      this.obs = _data['obs'];
    }
  }

  static fromJS(data: any): ContratosTransportadoresDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContratosTransportadoresDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['local'] = this.local;
    data['contrato'] = this.contrato;
    data['transportadora'] = this.transportadora;
    data['quantidade'] = this.quantidade;
    data['quantidadeTransportada'] = this.quantidadeTransportada;
    data['obs'] = this.obs;
    return data;
  }
}

export class DefinicaoQuantidadeResponse {
  transportador?: string | undefined;
  unidade!: string | undefined;
  quantidade?: number | undefined;
  saldo?: number | undefined;
  quantidadeTransportada?: number | undefined;
  matricula?: number | undefined;
  obs?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.transportador = _data['transportador'];
      this.unidade = _data['unidade'];
      this.quantidade = _data['quantidade'];
      this.saldo = _data['saldo'];
      this.quantidadeTransportada = _data['quantidadeTransportada'];
      this.matricula = _data['matricula'];
      this.obs = _data['obs'];
    }
  }

  static fromJS(data: any): DefinicaoQuantidadeResponse {
    data = typeof data === 'object' ? data : {};
    let result = new DefinicaoQuantidadeResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['transportador'] = this.transportador;
    data['unidade'] = this.unidade;
    data['quantidade'] = this.quantidade;
    data['saldo'] = this.saldo;
    data['quantidadeTransportada'] = this.quantidadeTransportada;
    data['matricula'] = this.matricula;
    data['obs'] = this.obs;
    return data;
  }
}

export class DefinicaoQuantidadeResponseListResult {
  data?: DefinicaoQuantidadeResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(DefinicaoQuantidadeResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): DefinicaoQuantidadeResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new DefinicaoQuantidadeResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class ExceptionDto {
  message?: string | undefined;
  stacktrace?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.message = _data['message'];
      this.stacktrace = _data['stacktrace'];
    }
  }

  static fromJS(data: any): ExceptionDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExceptionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['message'] = this.message;
    data['stacktrace'] = this.stacktrace;
    return data;
  }
}

export enum FiltroAgendamento {
  PendentesECarregado = 'PendentesECarregado',
  Carregado = 'Carregado',
  Pendentes = 'Pendentes',
  Cancelados = 'Cancelados'
}

export enum FiltroSolicitacaoPagamentoFrete {
  Abertos = 'Abertos',
  Cancelados = 'Cancelados',
  AguardadndoPagamento = 'AguardadndoPagamento',
  Pagos = 'Pagos'
}

export class HistoricoSolicitacaoPagamentoFreteDetalheResponse {
  data?: Date | undefined;
  sequencia?: number;
  descricao?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.data = _data['data'] ? new Date(_data['data'].toString()) : (undefined as any);
      this.sequencia = _data['sequencia'];
      this.descricao = _data['descricao'];
    }
  }

  static fromJS(data: any): HistoricoSolicitacaoPagamentoFreteDetalheResponse {
    data = typeof data === 'object' ? data : {};
    let result = new HistoricoSolicitacaoPagamentoFreteDetalheResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data ? this.data.toISOString() : (undefined as any);
    data['sequencia'] = this.sequencia;
    data['descricao'] = this.descricao;
    return data;
  }
}

export class HistoricoSolicitacaoPagamentoFreteResponse {
  contrato?: number;
  ordem?: number;
  nota?: number;
  serieNota?: number;
  pesoSaida?: number;
  cte?: number;
  serieCte?: number;
  pesoChegada?: number;
  detalhes?: HistoricoSolicitacaoPagamentoFreteDetalheResponse[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.contrato = _data['contrato'];
      this.ordem = _data['ordem'];
      this.nota = _data['nota'];
      this.serieNota = _data['serieNota'];
      this.pesoSaida = _data['pesoSaida'];
      this.cte = _data['cte'];
      this.serieCte = _data['serieCte'];
      this.pesoChegada = _data['pesoChegada'];
      if (Array.isArray(_data['detalhes'])) {
        this.detalhes = [] as any;
        for (let item of _data['detalhes'])
          this.detalhes!.push(HistoricoSolicitacaoPagamentoFreteDetalheResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): HistoricoSolicitacaoPagamentoFreteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new HistoricoSolicitacaoPagamentoFreteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contrato'] = this.contrato;
    data['ordem'] = this.ordem;
    data['nota'] = this.nota;
    data['serieNota'] = this.serieNota;
    data['pesoSaida'] = this.pesoSaida;
    data['cte'] = this.cte;
    data['serieCte'] = this.serieCte;
    data['pesoChegada'] = this.pesoChegada;
    if (Array.isArray(this.detalhes)) {
      data['detalhes'] = [];
      for (let item of this.detalhes)
        data['detalhes'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export class HistoricoSolicitacaoPagamentoFreteResponseResult {
  data?: HistoricoSolicitacaoPagamentoFreteResponse;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.data = _data['data']
        ? HistoricoSolicitacaoPagamentoFreteResponse.fromJS(_data['data'])
        : (undefined as any);
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): HistoricoSolicitacaoPagamentoFreteResponseResult {
    data = typeof data === 'object' ? data : {};
    let result = new HistoricoSolicitacaoPagamentoFreteResponseResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data ? this.data.toJSON() : (undefined as any);
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class ProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export class HttpValidationProblemDetails extends ProblemDetails {
  errors?: { [key: string]: string[] } | undefined;

  [key: string]: any;

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      if (_data['errors']) {
        this.errors = {} as any;
        for (let key in _data['errors']) {
          if (_data['errors'].hasOwnProperty(key))
            (this.errors as any)![key] =
              _data['errors'][key] !== undefined ? _data['errors'][key] : [];
        }
      }
    }
  }

  static override fromJS(data: any): HttpValidationProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new HttpValidationProblemDetails();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    if (this.errors) {
      data['errors'] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (data['errors'] as any)[key] = (this.errors as any)[key];
      }
    }
    super.toJSON(data);
    return data;
  }
}

export class MatriculasFilialResponse {
  filial!: number;
  cnpj!: string | undefined;
  cidade!: string | undefined;
  bairro?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.filial = _data['filial'];
      this.cnpj = _data['cnpj'];
      this.cidade = _data['cidade'];
      this.bairro = _data['bairro'];
    }
  }

  static fromJS(data: any): MatriculasFilialResponse {
    data = typeof data === 'object' ? data : {};
    let result = new MatriculasFilialResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['filial'] = this.filial;
    data['cnpj'] = this.cnpj;
    data['cidade'] = this.cidade;
    data['bairro'] = this.bairro;
    return data;
  }
}

export class MatriculasFilialResponseListResult {
  data?: MatriculasFilialResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(MatriculasFilialResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): MatriculasFilialResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new MatriculasFilialResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class ObservacaoPagamentoFreteRequest {
  observacao!: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.observacao = _data['observacao'];
    }
  }

  static fromJS(data: any): ObservacaoPagamentoFreteRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ObservacaoPagamentoFreteRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['observacao'] = this.observacao;
    return data;
  }
}

export class ObservacaoPagamentoFreteResponse {
  id?: number;
  observacao?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.observacao = _data['observacao'];
    }
  }

  static fromJS(data: any): ObservacaoPagamentoFreteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ObservacaoPagamentoFreteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['observacao'] = this.observacao;
    return data;
  }
}

export class ObservacaoPagamentoFreteResponseListResult {
  data?: ObservacaoPagamentoFreteResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(ObservacaoPagamentoFreteResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): ObservacaoPagamentoFreteResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new ObservacaoPagamentoFreteResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class ObservacaoPagamentoFreteResponseResult {
  data?: ObservacaoPagamentoFreteResponse;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.data = _data['data']
        ? ObservacaoPagamentoFreteResponse.fromJS(_data['data'])
        : (undefined as any);
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): ObservacaoPagamentoFreteResponseResult {
    data = typeof data === 'object' ? data : {};
    let result = new ObservacaoPagamentoFreteResponseResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data ? this.data.toJSON() : (undefined as any);
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export enum PermissaoTransportadora {
  Agendamentos = 'Agendamentos',
  Pagamentos = 'Pagamentos'
}

export class PermissaoTransportadoraBooleanKeyValuePair {
  key?: PermissaoTransportadora;
  value?: boolean;

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): PermissaoTransportadoraBooleanKeyValuePair {
    data = typeof data === 'object' ? data : {};
    let result = new PermissaoTransportadoraBooleanKeyValuePair();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['value'] = this.value;
    return data;
  }
}

export class PermissoesFobTransportadoraResponse {
  matriculaMatriz!: string | undefined;
  razaoSocial!: string | undefined;
  matriculaFornecedor?: number | undefined;

  init(_data?: any) {
    if (_data) {
      this.matriculaMatriz = _data['matriculaMatriz'];
      this.razaoSocial = _data['razaoSocial'];
      this.matriculaFornecedor = _data['matriculaFornecedor'];
    }
  }

  static fromJS(data: any): PermissoesFobTransportadoraResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PermissoesFobTransportadoraResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['matriculaMatriz'] = this.matriculaMatriz;
    data['razaoSocial'] = this.razaoSocial;
    data['matriculaFornecedor'] = this.matriculaFornecedor;
    return data;
  }
}

export class PermissoesFobTransportadoraResponseIEnumerableResult {
  data?: PermissoesFobTransportadoraResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(PermissoesFobTransportadoraResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): PermissoesFobTransportadoraResponseIEnumerableResult {
    data = typeof data === 'object' ? data : {};
    let result = new PermissoesFobTransportadoraResponseIEnumerableResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class PermissoesFobTransportadoraResponseResult {
  data?: PermissoesFobTransportadoraResponse;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.data = _data['data']
        ? PermissoesFobTransportadoraResponse.fromJS(_data['data'])
        : (undefined as any);
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): PermissoesFobTransportadoraResponseResult {
    data = typeof data === 'object' ? data : {};
    let result = new PermissoesFobTransportadoraResponseResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data ? this.data.toJSON() : (undefined as any);
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class PermissoesTransportadoraResponse {
  matricula?: number;
  razaoSocial?: string | undefined;
  cnpj?: string | undefined;
  permissoes?: PermissaoTransportadoraBooleanKeyValuePair[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.matricula = _data['matricula'];
      this.razaoSocial = _data['razaoSocial'];
      this.cnpj = _data['cnpj'];
      if (Array.isArray(_data['permissoes'])) {
        this.permissoes = [] as any;
        for (let item of _data['permissoes'])
          this.permissoes!.push(PermissaoTransportadoraBooleanKeyValuePair.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PermissoesTransportadoraResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PermissoesTransportadoraResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['matricula'] = this.matricula;
    data['razaoSocial'] = this.razaoSocial;
    data['cnpj'] = this.cnpj;
    if (Array.isArray(this.permissoes)) {
      data['permissoes'] = [];
      for (let item of this.permissoes)
        data['permissoes'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export class PermissoesTransportadoraResponseListResult {
  data?: PermissoesTransportadoraResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(PermissoesTransportadoraResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): PermissoesTransportadoraResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new PermissoesTransportadoraResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class PostVeiculoRequest {
  placaDoCavalo?: string | undefined;
  tipo?: string | undefined;
  anoFabricacao?: number;
  anoModelo?: number;
  marca?: string | undefined;
  numeroDeEixos?: number;
  transportadora?: number;
  cnpjCpfProprietario?: string | undefined;
  placaReboque1?: string | undefined;
  numeroDeEixos1?: number;
  tipo1?: string | undefined;
  placaReboque2?: string | undefined;
  numeroDeEixos2?: number;
  tipo2?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.placaDoCavalo = _data['placaDoCavalo'];
      this.tipo = _data['tipo'];
      this.anoFabricacao = _data['anoFabricacao'];
      this.anoModelo = _data['anoModelo'];
      this.marca = _data['marca'];
      this.numeroDeEixos = _data['numeroDeEixos'];
      this.transportadora = _data['transportadora'];
      this.cnpjCpfProprietario = _data['cnpjCpfProprietario'];
      this.placaReboque1 = _data['placaReboque1'];
      this.numeroDeEixos1 = _data['numeroDeEixos1'];
      this.tipo1 = _data['tipo1'];
      this.placaReboque2 = _data['placaReboque2'];
      this.numeroDeEixos2 = _data['numeroDeEixos2'];
      this.tipo2 = _data['tipo2'];
    }
  }

  static fromJS(data: any): PostVeiculoRequest {
    data = typeof data === 'object' ? data : {};
    let result = new PostVeiculoRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['placaDoCavalo'] = this.placaDoCavalo;
    data['tipo'] = this.tipo;
    data['anoFabricacao'] = this.anoFabricacao;
    data['anoModelo'] = this.anoModelo;
    data['marca'] = this.marca;
    data['numeroDeEixos'] = this.numeroDeEixos;
    data['transportadora'] = this.transportadora;
    data['cnpjCpfProprietario'] = this.cnpjCpfProprietario;
    data['placaReboque1'] = this.placaReboque1;
    data['numeroDeEixos1'] = this.numeroDeEixos1;
    data['tipo1'] = this.tipo1;
    data['placaReboque2'] = this.placaReboque2;
    data['numeroDeEixos2'] = this.numeroDeEixos2;
    data['tipo2'] = this.tipo2;
    return data;
  }
}

export class PostVeiculoRequestResult {
  data?: PostVeiculoRequest;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.data = _data['data'] ? PostVeiculoRequest.fromJS(_data['data']) : (undefined as any);
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): PostVeiculoRequestResult {
    data = typeof data === 'object' ? data : {};
    let result = new PostVeiculoRequestResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data ? this.data.toJSON() : (undefined as any);
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class RelatorioResponse {
  mensagem?: string | undefined;
  enviado?: boolean;
  emails?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.mensagem = _data['mensagem'];
      this.enviado = _data['enviado'];
      if (Array.isArray(_data['emails'])) {
        this.emails = [] as any;
        for (let item of _data['emails']) this.emails!.push(item);
      }
    }
  }

  static fromJS(data: any): RelatorioResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RelatorioResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['mensagem'] = this.mensagem;
    data['enviado'] = this.enviado;
    if (Array.isArray(this.emails)) {
      data['emails'] = [];
      for (let item of this.emails) data['emails'].push(item);
    }
    return data;
  }
}

export class RelatorioResponseResult {
  data?: RelatorioResponse;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.data = _data['data'] ? RelatorioResponse.fromJS(_data['data']) : (undefined as any);
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): RelatorioResponseResult {
    data = typeof data === 'object' ? data : {};
    let result = new RelatorioResponseResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data ? this.data.toJSON() : (undefined as any);
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class SolicitacaoPagamentoFreteAnexoResponse {
  id?: string;
  anexos?: AnexoPagamentoFreteResponse[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      if (Array.isArray(_data['anexos'])) {
        this.anexos = [] as any;
        for (let item of _data['anexos'])
          this.anexos!.push(AnexoPagamentoFreteResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SolicitacaoPagamentoFreteAnexoResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SolicitacaoPagamentoFreteAnexoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    if (Array.isArray(this.anexos)) {
      data['anexos'] = [];
      for (let item of this.anexos) data['anexos'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export class SolicitacaoPagamentoFreteAnexoResponseResult {
  data?: SolicitacaoPagamentoFreteAnexoResponse;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      this.data = _data['data']
        ? SolicitacaoPagamentoFreteAnexoResponse.fromJS(_data['data'])
        : (undefined as any);
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): SolicitacaoPagamentoFreteAnexoResponseResult {
    data = typeof data === 'object' ? data : {};
    let result = new SolicitacaoPagamentoFreteAnexoResponseResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data ? this.data.toJSON() : (undefined as any);
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class SolicitacaoPagamentoFreteResponse {
  contrato?: number;
  ordem?: number;
  nota?: number;
  serieNota?: string | undefined;
  data?: Date | undefined;
  tarifa?: number;
  valorCalculado?: number;
  valorExtra?: number;
  acrescimo?: number;
  valorAReceber?: number;
  pesoSaida?: number;
  pesoChegada?: number;
  cte?: number;
  serieCte?: string | undefined;
  situacao?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.contrato = _data['contrato'];
      this.ordem = _data['ordem'];
      this.nota = _data['nota'];
      this.serieNota = _data['serieNota'];
      this.data = _data['data'] ? new Date(_data['data'].toString()) : (undefined as any);
      this.tarifa = _data['tarifa'];
      this.valorCalculado = _data['valorCalculado'];
      this.valorExtra = _data['valorExtra'];
      this.acrescimo = _data['acrescimo'];
      this.valorAReceber = _data['valorAReceber'];
      this.pesoSaida = _data['pesoSaida'];
      this.pesoChegada = _data['pesoChegada'];
      this.cte = _data['cte'];
      this.serieCte = _data['serieCte'];
      this.situacao = _data['situacao'];
    }
  }

  static fromJS(data: any): SolicitacaoPagamentoFreteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SolicitacaoPagamentoFreteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contrato'] = this.contrato;
    data['ordem'] = this.ordem;
    data['nota'] = this.nota;
    data['serieNota'] = this.serieNota;
    data['data'] = this.data ? this.data.toISOString() : (undefined as any);
    data['tarifa'] = this.tarifa;
    data['valorCalculado'] = this.valorCalculado;
    data['valorExtra'] = this.valorExtra;
    data['acrescimo'] = this.acrescimo;
    data['valorAReceber'] = this.valorAReceber;
    data['pesoSaida'] = this.pesoSaida;
    data['pesoChegada'] = this.pesoChegada;
    data['cte'] = this.cte;
    data['serieCte'] = this.serieCte;
    data['situacao'] = this.situacao;
    return data;
  }
}

export class SolicitacaoPagamentoFreteResponseListResult {
  data?: SolicitacaoPagamentoFreteResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      const solicitacoesData = _data['data']?.['result'] ?? _data['data'];
      if (Array.isArray(solicitacoesData)) {
        this.data = [] as any;
        for (let item of solicitacoesData)
          this.data!.push(SolicitacaoPagamentoFreteResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): SolicitacaoPagamentoFreteResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new SolicitacaoPagamentoFreteResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class SolicitacaoPagamentoFreteUpdate {
  pesoChegada!: number;
  cte!: number;
  serieCte!: string | undefined;
  ordem!: number;

  init(_data?: any) {
    if (_data) {
      this.pesoChegada = _data['pesoChegada'];
      this.cte = _data['cte'];
      this.serieCte = _data['serieCte'];
      this.ordem = _data['ordem'];
    }
  }

  static fromJS(data: any): SolicitacaoPagamentoFreteUpdate {
    data = typeof data === 'object' ? data : {};
    let result = new SolicitacaoPagamentoFreteUpdate();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['pesoChegada'] = this.pesoChegada;
    data['cte'] = this.cte;
    data['serieCte'] = this.serieCte;
    data['ordem'] = this.ordem;
    return data;
  }
}

export class StringStringKeyValuePair {
  key?: string | undefined;
  value?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): StringStringKeyValuePair {
    data = typeof data === 'object' ? data : {};
    let result = new StringStringKeyValuePair();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['value'] = this.value;
    return data;
  }
}

export class StringStringKeyValuePairListResult {
  data?: StringStringKeyValuePair[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(StringStringKeyValuePair.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): StringStringKeyValuePairListResult {
    data = typeof data === 'object' ? data : {};
    let result = new StringStringKeyValuePairListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class TipoVeiculosResponse {
  tipo?: string | undefined;
  descricao?: string | undefined;

  init(_data?: any) {
    if (_data) {
      this.tipo = _data['tipo'];
      this.descricao = _data['descricao'];
    }
  }

  static fromJS(data: any): TipoVeiculosResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TipoVeiculosResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tipo'] = this.tipo;
    data['descricao'] = this.descricao;
    return data;
  }
}

export class TipoVeiculosResponseListResult {
  data?: TipoVeiculosResponse[] | undefined;
  errors?: string[] | undefined;

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(TipoVeiculosResponse.fromJS(item));
      }
      if (Array.isArray(_data['errors'])) {
        this.errors = [] as any;
        for (let item of _data['errors']) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): TipoVeiculosResponseListResult {
    data = typeof data === 'object' ? data : {};
    let result = new TipoVeiculosResponseListResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item);
    }
    return data;
  }
}

export class Body {
  matricula!: number;
  contrato!: number;
  nota!: number;
  cteNfse!: number;
  nfse?: string | undefined;
  cte?: string | undefined;
  ticket?: string | undefined;
  nfseXml?: string | undefined;
  cteLink?: string | undefined;
  observacao?: string | undefined;

  [key: string]: any;

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.matricula = _data['Matricula'];
      this.contrato = _data['Contrato'];
      this.nota = _data['Nota'];
      this.cteNfse = _data['CteNfse'];
      this.nfse = _data['Nfse'];
      this.cte = _data['Cte'];
      this.ticket = _data['Ticket'];
      this.nfseXml = _data['NfseXml'];
      this.cteLink = _data['CteLink'];
      this.observacao = _data['Observacao'];
    }
  }

  static fromJS(data: any): Body {
    data = typeof data === 'object' ? data : {};
    let result = new Body();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['Matricula'] = this.matricula;
    data['Contrato'] = this.contrato;
    data['Nota'] = this.nota;
    data['CteNfse'] = this.cteNfse;
    data['Nfse'] = this.nfse;
    data['Cte'] = this.cte;
    data['Ticket'] = this.ticket;
    data['NfseXml'] = this.nfseXml;
    data['CteLink'] = this.cteLink;
    data['Observacao'] = this.observacao;
    return data;
  }
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}

export {};
